import React, { useState } from 'react';
import { Send } from 'react-feather';
import './InlineForm.css';
import logger from '../../../../../../utils/logger';

function InlineForm({ 
  form, 
  onSubmit, 
  botMessageBoxColor = '#f0f0f0', 
  botMessageTextColor = '#333',
  userMessageBoxColor = '#007bff',
  userMessageTextColor = '#fff'
}) {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (fieldName, value) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));
    
    // Clear error when user starts typing
    if (errors[fieldName]) {
      setErrors(prev => ({
        ...prev,
        [fieldName]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    form.fields.forEach(field => {
      if (field.required && (!formData[field.name] || formData[field.name].trim() === '')) {
        newErrors[field.name] = `${field.name} is required`;
      }
      
      // Additional validation for email fields
      if (field.type === 'email' && formData[field.name]) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData[field.name])) {
          newErrors[field.name] = 'Please enter a valid email address';
        }
      }
      
      // Additional validation for phone fields
      if (field.type === 'tel' && formData[field.name]) {
        const phoneRegex = /^[\d\s\-+()]+$/;
        if (!phoneRegex.test(formData[field.name])) {
          newErrors[field.name] = 'Please enter a valid phone number';
        }
      }
    });
    
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      await onSubmit(formData, form.step);
    } catch (error) {
      logger.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="inline-form-container">
      <div 
        className="inline-form-bubble"
        style={{ 
          backgroundColor: botMessageBoxColor, 
          color: botMessageTextColor,
          '--bubble-color': botMessageBoxColor
        }}
      >
        <div className="inline-form-prompt">
          {form.prompt}
        </div>
        
        <form onSubmit={handleSubmit} className="inline-form">
          {form.fields.map((field, index) => (
            <div key={index} className="inline-form-field">
              {field.type === 'textarea' ? (
                <textarea
                  value={formData[field.name] || ''}
                  onChange={(e) => handleInputChange(field.name, e.target.value)}
                  className={`inline-form-input ${errors[field.name] ? 'error' : ''}`}
                  placeholder={`${field.name}${field.required ? ' *' : ''}`}
                  rows={3}
                  disabled={isSubmitting}
                  style={{ height: '50px' }}
                />
              ) : (
                <input
                  type={field.type}
                  value={formData[field.name] || ''}
                  onChange={(e) => handleInputChange(field.name, e.target.value)}
                  className={`inline-form-input ${errors[field.name] ? 'error' : ''}`}
                  placeholder={`${field.name}${field.required ? ' *' : ''}`}
                  disabled={isSubmitting}
                  style={{ height: '50px' }}
                />
              )}
              
              {errors[field.name] && (
                <span className="inline-form-error">{errors[field.name]}</span>
              )}
            </div>
          ))}
          
          <button
            type="submit"
            className="inline-form-submit"
            disabled={isSubmitting}
            style={{
              backgroundColor: userMessageBoxColor,
              color: userMessageTextColor
            }}
          >
            <Send size={16} />
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default InlineForm; 